import { createSlice } from '@reduxjs/toolkit'

const url = window.location.href;
let urlLang = {label: 'en', value: 'en_US'}
if(url.indexOf('/pl/')>0){
    urlLang = { value: 'pl_PL', label: 'pl' };    
}
console.log("url", url);
const initLang = JSON.parse(localStorage.getItem('lang') || JSON.stringify(urlLang))

export const langSlice = createSlice({
    name: 'lang',
    initialState: {
        lang: initLang
    },
    reducers: {
        setLang: (state, action) => {
            console.log(action.payload);
            state.lang = action.payload
            localStorage.setItem('lang', JSON.stringify(action.payload));
        },
    },
})

// Action creators are generated for each case reducer function
export const { setLang } = langSlice.actions

export default langSlice.reducer
